import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';

export const useChartsData = (queryConfig, filters) => {
    const isSamu = queryConfig.url.includes('dashboardsamu');
    const samuCityId = useSelector((state) => state.core.session.samu_city_id);

    return useQuery({
        queryKey: [
            queryConfig.key,
            filters.location,
            filters.year,
            filters.month,
            isSamu ? samuCityId : null
        ],
        queryFn: async ({ signal }) => {
            let requestFilters = {};

            if (queryConfig.url.includes('sihsus')) {
                requestFilters = {
                    filters: {
                        mes_competencia: filters.month,
                        ano_competencia: filters.year,
                        cnes: filters.location?.split(',')
                    }
                };
            } else if (isSamu) {
                requestFilters = {
                    filters: {
                        mes: filters.month,
                        ano: filters.year,
                        city_id: samuCityId
                    }
                };
            }else {
                requestFilters = {
                    filters: {
                        mes_competencia: filters.month,
                        ano_competencia: filters.year,
                        pa_coduni: filters.location?.split(',')
                       
                    }
                };
            }
            return await Fetch.post(
                config.integration.governanceroom + queryConfig.url,
                requestFilters,
                signal
            );
        },
        enabled:
            !!filters.year &&
            !!filters.location &&
            (!isSamu || !!samuCityId),
        staleTime: 1000 * 60 * 60
    });
};

const AGE_GROUP = 'age-group-services';
const COMPLEXETY_LEVEL = 'complexity-level-services';
const GENDER = 'gender-services';
const PRODUCTION_SITUATION = 'production-situation-services';
const RACE_COLOR = 'race-color-services';
const GENERAL_RESULTS = 'general-results-services';
const DISCHARGE = 'discharge-services';
const OUTS = 'outs-services';
const SERVICES = 'services';
const PRODUCTION_VALUE = 'production-value-services';
const PRODUCTION_QUANTITY = 'production-quantity-services';
const INCREASE_IN_VALUES = 'increase-in-values-services';
const PRINCIPAL_CID = 'principal-cid-services';
const PROCEDURES = 'procedures-services';
const CITY = 'city-services';

export const QUERY_KEYS_SIA = {
    AGE_GROUP,
    COMPLEXETY_LEVEL,
    GENDER,
    PRODUCTION_SITUATION,
    RACE_COLOR,
    GENERAL_RESULTS,
    DISCHARGE,
    OUTS,
    SERVICES,
    PRODUCTION_VALUE,
    PRODUCTION_QUANTITY,
    INCREASE_IN_VALUES,
    PRINCIPAL_CID,
    PROCEDURES,
    CITY
};

const GENERAL_RESULTS_AIH_SIH = 'general-results-aih-sih';
const CHARACTER_OF_ADMISSSION_AIH_SIH = 'character-of-admission-aih-sih';
const SPECIALITIES_AIH_SIH = 'specialities-aih-sih';
const ETHNICITY_PERFIL_SIH = 'ethnicity-perfil-sih';
const AGE_GROUP_PERFIL_SIH = 'age-group-perfil-sih';
const GENDER_PERFIL_SIH = 'gender-perfil-sih';
const EDUCATION_PERFIL_SIH = 'education-perfil-sih';
const CITY_PERFIL_SIH = 'city-perfil-sih';
const COMPLEXETY_LEVEL_AIH_SIH = 'complexity-level-aih-sih';
const PERMANENCE_DAYS_HOSPITALIZATION_SIH =
    'permanence-days-hospitalization_sih';
const TOTALS_HOSPITALIZATION_SIH = 'totals-hospitalization-sih';
const TOTAL_UTILIZATION_MONTH_SIH = 'total-utilization-month-uti-sih';
const INTERMIDIATE_CARE_UNIT_SIH = 'intermidiate-care-unit-uti-sih';
const UTI_TYPE_SIH = 'uti-type-sih';
const UTI_VALUE_SIH = 'uti-value-uti-sih';
const IND_VDLR_SIH = 'ind-vdlr_procedures-sih';
const HOSPITAL_INFECTION_SIH = 'hospital-infection-procedures-sih';
const PREGANT_SIH = 'pregnant-procedures-sih';
const DEATH_TYPE_SIH = 'death-discharge-sih';
const PROCEDURES_LIST_SIH = 'procedures-list-procedures-sih';
const FINANCING_TYPE_REVENUE_SIH = 'financing-type-revenue-sih';
const FEDERAL_REVENUE_SIH = 'federal-revenue-sih';
const MANAGEMENT_REVENUE_AIH = 'management-revenue-aih';
const INDICATORS_REVENUE_SIH = 'indicators-revenue-sih';
const TOTAL_REVENUE_SIH = 'total-revenue-sih';

export const QUERY_KEYS_SIH = {
    GENERAL_RESULTS_AIH: GENERAL_RESULTS_AIH_SIH,
    SPECIALITIES_AIH: SPECIALITIES_AIH_SIH,
    ETHNICITY_PERFIL: ETHNICITY_PERFIL_SIH,
    AGE_GROUP_PERFIL: AGE_GROUP_PERFIL_SIH,
    GENDER_PERFIL: GENDER_PERFIL_SIH,
    EDUCATION_PERFIL: EDUCATION_PERFIL_SIH,
    CITY_PERFIL: CITY_PERFIL_SIH,
    CHARACTER_OF_ADMISSSION: CHARACTER_OF_ADMISSSION_AIH_SIH,
    COMPLEXETY_LEVEL: COMPLEXETY_LEVEL_AIH_SIH,
    PERMANENCE_DAYS_HOSPITALIZATION: PERMANENCE_DAYS_HOSPITALIZATION_SIH,
    TOTALS_HOSPITALIZATION: TOTALS_HOSPITALIZATION_SIH,
    TOTAL_UTILIZATION_MONTH: TOTAL_UTILIZATION_MONTH_SIH,
    INTERMIDIATE_CARE_UNIT: INTERMIDIATE_CARE_UNIT_SIH,
    UTI_TYPE: UTI_TYPE_SIH,
    UTI_VALUE: UTI_VALUE_SIH,
    IND_VDLR: IND_VDLR_SIH,
    HOSPITAL_INFECTION: HOSPITAL_INFECTION_SIH,
    PREGANT: PREGANT_SIH,
    DEATH_TYPE: DEATH_TYPE_SIH,
    PROCEDURES_LIST: PROCEDURES_LIST_SIH,
    FINANCING_TYPE: FINANCING_TYPE_REVENUE_SIH,
    FEDERAL: FEDERAL_REVENUE_SIH,
    MANAGEMENT: MANAGEMENT_REVENUE_AIH,
    INDICATORS: INDICATORS_REVENUE_SIH,
    TOTAL: TOTAL_REVENUE_SIH
};

const GENERAL_RESULTS_SAMU = 'general-results-samu';
const PERIOD_SAMU = 'period-samu';
const PROFILE_SAMU = 'profile-samu';
const SECTORIZATION_SAMU = 'sectorization-samu';
const SPECIAL_CARE_SAMU = 'special-care-samu';
const APH_RESULTS_SAMU = 'aph-results-samu';
const REGULATION_RESULTS_SAMU = 'regulation-results-samu';
const CALLS_RESULTS_SAMU = 'calls-results-samu';
const PRIORITY_RESULTS_SAMU = 'priority-results-samu';

export const QUERY_KEYS_SAMU = {
    GENERAL_RESULTS: GENERAL_RESULTS_SAMU,
    PERIOD: PERIOD_SAMU,
    PROFILE: PROFILE_SAMU,
    SECTORIZATION: SECTORIZATION_SAMU,
    SPECIAL_CARE: SPECIAL_CARE_SAMU,
    APH_RESULTS: APH_RESULTS_SAMU,
    REGULATION_RESULTS: REGULATION_RESULTS_SAMU,
    CALLS_RESULTS: CALLS_RESULTS_SAMU,
    PRIORITY_RESULTS: PRIORITY_RESULTS_SAMU
};
